/** kebab-case sem acento + sufixo de 4 dígitos (ex. cluster-tecnologia-lyceum-8372). */

const SLUG_BASE_MAX = 36;

export function slugBaseFromProductName(name: string): string {
  const base = name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-');
  if (!base) {
    return '';
  }
  const withLetter = /^[a-z]/.test(base) ? base : `p-${base}`;
  return withLetter.slice(0, SLUG_BASE_MAX).replace(/-+$/g, '');
}

export function randomSlugHash(): string {
  return String(1000 + Math.floor(Math.random() * 9000));
}

export function hash4FromBase(base: string): string {
  let h = 2166136261;
  for (let i = 0; i < base.length; i += 1) {
    h ^= base.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return String(1000 + ((h >>> 0) % 9000));
}

export function parseProductSlug(
  slug: string,
): { base: string; hash: string } | null {
  const match = slug.trim().match(/^([a-z][a-z0-9-]*)-(\d{4})$/);
  if (!match) {
    return null;
  }
  return { base: match[1], hash: match[2] };
}

export function productSlugFromName(
  name: string,
  _previousSlug?: string | null,
): string {
  const base = slugBaseFromProductName(name);
  if (!base) {
    return '';
  }
  return `${base}-${hash4FromBase(base)}`;
}

export const PRODUCT_SLUG_PATTERN = '^[a-z][a-z0-9-]*-[0-9]{4}$';

export function slugLastTwoSegments(slug: string): string {
  const parts = slug.trim().split('-').filter(Boolean);
  if (parts.length === 0) {
    return '';
  }
  if (parts.length === 1) {
    return parts[0];
  }
  return parts.slice(-2).join('-');
}
